import { render } from "./AcompanharDenunciaElement.vue?vue&type=template&id=2a9db3c5&scoped=true"
import script from "./AcompanharDenunciaElement.vue?vue&type=script&lang=js"
export * from "./AcompanharDenunciaElement.vue?vue&type=script&lang=js"

import "./AcompanharDenunciaElement.vue?vue&type=style&index=0&id=2a9db3c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9db3c5"]])

export default __exports__